import { useCallback } from 'react'
import styled from 'styled-components'
import ChevronIcon from '@/components/icons/ChevronIcon'
import PaginationDot from './PaginationDot'

const Container = styled.div`
  max-width: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  color: white;
  min-height: 60px;
  height: 60px;
  flex-grow: 0;
`

const Side = styled.div`
  min-width: 50px;
  max-width: 140px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 0;
`

const Left = styled(Side)`
  justify-content: flex-start;
`

const Right = styled(Side)`
  justify-content: flex-end;
`

const Center = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  overflow: hidden;
  flex-grow: 1;
`

const Button = styled.div<{ disabled?: boolean }>`
  width: 45px;
  height: 45px;
  border-radius: 100%;
  border-style: solid;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #333B4F;
  border-width: 0px;
  ${props => props.disabled ? 'opacity: 0.25;' : 'cursor: pointer;'}
`

interface FooterProps {
  totalPages: number
  currentPage: number
  setPage: (page: number) => void
}

const Footer = ({ totalPages, currentPage, setPage }: FooterProps) => {
  const pagesArray = Array(totalPages).fill("")

  const changePage = useCallback((forward: boolean) => {
    if (forward && (pagesArray.length - 1 > currentPage)) {
      setPage(currentPage + 1)
    } else if (!forward && currentPage > 0) {
      setPage(currentPage - 1)
    }
  }, [currentPage, setPage, pagesArray])

  return (
    <Container>
      <Left>
        <Button disabled={currentPage == 0} onClick={() => changePage(false)}>
          <ChevronIcon style={{ width: '9px', height: '17px', marginLeft: '-2px' }} />
        </Button>
      </Left>
      <Center>
        {pagesArray.map((_page, i) => <PaginationDot key={`page_${i}`} page={i} active={i === currentPage} setPage={setPage} /> )}
      </Center>
      <Right>
        <Button disabled={pagesArray.length - 1 === currentPage} onClick={() => changePage(true)}>
          <ChevronIcon style={{ width: '9px', height: '17px', marginLeft: '2px', transform: 'rotate(180deg)' }} />
        </Button>
      </Right>
    </Container>
  )
}

export default Footer
